<div class="modal-container">
  <button
    id="modalFechaCorteButton"
    #modalFechaCorteButton
    data-bs-toggle="modal"
    data-bs-target="#modalFechaCorte"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalFechaCorte"
    tabindex="-1"
    aria-labelledby="modalFechaCorteLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalFechaCorteLabel">
            Seleccionar Fecha de Corte
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label for="fecha">Seleccione una fecha:</label>
          <input
            type="date"
            id="fecha"
            [(ngModel)]="fecha"
            [max]="fechaMaxima"
            class="form-control" />
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn-govco btn-govco"
            data-bs-dismiss="modal"
            aria-label="Cancelar">
            Cancelar
          </button>
          <button
            type="button"
            class="btn-govco fill-btn-govco"
            (click)="guardarFecha()"
            data-bs-dismiss="modal"
            aria-label="Guardar">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
